import { useDispatch, useSelector } from 'react-redux';

import {
  GetSuppliesList,
  CreateSuppliesList,
  UpdateSuppliesList,
  DeleteSuppliesList,
} from '../../../store/actions';

/**
 * SuppliersInjection is responsible for injecting the data into the Accounts page.
 *
 * @return
 */
export const SuppliersInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getSuppliers = async (filter) => {
    dispatch(GetSuppliesList(filter));
  };

  /**
   * @return Void
   */
  const deleteSuppliers = async (id) => {
    dispatch(DeleteSuppliesList(id));
  };

  /**
   * @return void
   */
  const createSuppliers = async (data) => {
    dispatch(CreateSuppliesList(data));
  };

  /**
   * @return void
   */
  const updateSuppliers = async (id, data) => {
    dispatch(UpdateSuppliesList(id, data));
  };

  /**
   * @return void
   */

  /**
   * @variables
   *
   * error: string
   * loading: boolean
   */
  const { suppliesList, success } = useSelector((state) => ({
    error: state.SuppliesList.error,
    suppliesList: state.SuppliesList.suppliesList,
    success: state.SuppliesList.success,
  }));

  return {
    getSuppliers,
    createSuppliers,
    deleteSuppliers,
    updateSuppliers,
    success,
    suppliesList,
  };
};
